
<template>
  <section
    id="corrosion_dataset"
    class="gradient corrosion-dataset"
    style="color: #ffffff"
  >
    <mdb-container>
      <div>
        <mdb-row class="pb-5">
          <mdb-col md="7">
            <h6 id="corrosionDatasetID" class="section-header-top">Dataset</h6>
            <h2>
              <a style="color: white !important"
                >Corrosion Image Data Set for Automating Scientific Assessment
                of Materials</a
              >
            </h2>
            <hr class="hr-light" />
            <p class="readable-text">
              The study of material corrosion is an important research area,
              with corrosion degradation of metallic structures causing expenses
              up to 4% of the global domestic product annually along with major
              safety risks worldwide. Unfortunately, large-scale and timely
              scientific discovery of materials has been hindered by the lack of
              standardized corrosion experimental data in the public domain for
              developing machine learning models. Obtaining such data is
              challenging due to the expert knowledge and time required to
              conduct these scientific experiments and assess corrosion levels.
              We curate a novel dataset consisting of 600 images annotated with
              expert corrosion ratings obtained over 10 years of laboratory
              corrosion testing by material scientists. Based on this data set,
              we find that non-experts even when rigorously trained with domain
              guidelines to rate corrosion fail to match expert ratings.
              Challenges include limited data, image artifacts, and
              millimeter-precision corrosion. This motivates us to explore the
              viability of deep learning approaches to tackle this benchmark
              classification task. We study (i) convolutional neural networks
              powered with rich domain-specific image augmentation techniques
              tuned to our data, and (ii) a recent self-supervised
              representation learning approach either pretrained on ImageNet or
              trained on our data. We demonstrate that pretrained ResNet-18 and
              HR-Net models with tuned augmentations can reach up to 0.83
              accuracy. With this corrosion data set, we open the door for the
              design of more advanced deep learning models to support this
              real-world task, while driving innovative new research to bridge
              computer vision and material innovation.
            </p>
            <mdb-row>
              <mdb-col md="3" class="max-width-col">
                <a href="https://www.bmvc2021-virtualconference.com/assets/papers/1544.pdf" class="text-white"><i class="fas fa-file-pdf i-white"></i>PAPER</a>
              </mdb-col>
              <mdb-col md="3" class="max-width-col">
                <a href="#" class="text-white"><i class="fab fa-github i-white"></i>CODE</a>
              </mdb-col>
              <mdb-col md="3" class="max-width-col">
                <a href="#" class="text-white"><i class="fas fa-file-powerpoint i-white"></i>SLIDES</a>
              </mdb-col>
              <mdb-col md="3" class="max-width-col">
                <a href="#" class="text-white"><i class="fab fa-youtube i-white"></i>VIDEO</a>
              </mdb-col>
            </mdb-row>
            <mdb-row>
              <mdb-col>
                <i class="fas fa-at i-white"></i
                ><span style="vertical-align: text-bottom"
                  >gr-wpi-arl-dsrg@wpi.edu</span
                >
                <!-- <router-link to="#aboutus"><mdb-btn outline="white">Contact Us</mdb-btn></router-link> -->
                <!-- @gr-wpi-arl-dsrg@wpi.edu -->
              </mdb-col>
            </mdb-row>
            <mdb-row>
              <mdb-col>
                <div>
                  <!-- <i class="fas fa-at"></i> gr-wpi-arl-dsrg@wpi.edu -->
                </div>
                <!-- <router-link to="#aboutus"><mdb-btn outline="white">Contact Us</mdb-btn></router-link> -->
              </mdb-col>
            </mdb-row>
            <!-- <mdb-btn v-if="project.url!=='javascript:void(0)'" outline="white" v-on:click.native="goto(project.url)">Learn More</mdb-btn> -->
          </mdb-col>
          <mdb-col md="5" class="">
            <mdb-card>
              <mdb-card-image
                :src="require(`@/assets/datasets/corrosion-dataset-sample.jpg`)"
                alt="Card image cap"
              ></mdb-card-image>
              <mdb-card-body>
                <mdb-card-title class="card-title" style="font-size: 1em"
                >MIT License © [2021] [Worcester Polytechnic Institute]
                </mdb-card-title>
                <mdb-card-text
                  >This corrosion image data set has been introduced by the
                  paper,<a href="#">
                    “Corrosion Image Data Set for Automating Scientific
                    Assessment of Materials”
                  </a>
                  published at the British Machine Vision Conference BMVC 2021.
                  Please follow the instructions below for downloading, use and
                  proper citation of the data set. Additional details on the
                  data included on the download is found in the downloaded
                  README file.</mdb-card-text
                >
                <!-- <mdbIcon style="color:blue" icon="github" size="3x"/> -->
                <div class="citation">
                  <span style="color: black;">Cite this dataset:</span>
                  <p style="padding-top:8px;">
                    @InProceedings{yin2021BMVC, author = {Yin, Biao and
                    Josselyn, Nicholas and Considine, Thomas and Kelley, John
                    and Rinderspacher, Berend and Jensen, Robert and Snyder,
                    James and Zhang, Ziming and Rundensteiner, Elke},title =
                    {Corrosion Image Data Set for Automating Scientific
                    Assessment of Materials},booktitle = {British Machine Vision
                    Conference (BMVC)},year = {2021}}
                  </p>
                </div>
                <mdb-row>
                  <mdb-col>
                    <span class="details"
                      ><i class="fas fa-images" /> 600 Images</span
                    >
                  </mdb-col>
                  <mdb-col>
                    <span class="details"
                      ><i class="fas fa-expand-arrows-alt" /> Size 512*512</span
                    >
                  </mdb-col>
                  <mdb-col>
                    <span class="details"
                      ><i class="fas fa-ellipsis-v" /> RGB (JPG)</span
                    >
                  </mdb-col>
                  <mdb-col>
                    <mdb-btn
                      color="primary"
                      style="float: right"
                      @click.native="modal = true"
                      >Download</mdb-btn
                    >
                  </mdb-col>
                </mdb-row>
              </mdb-card-body>
            </mdb-card>
          </mdb-col>
        </mdb-row>
      </div>
      <mdb-modal size="lg" :show="modal" @close="modal = false">
        <mdb-modal-header>
          <mdb-modal-title>Disclaimer</mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body>
          By downloading this code and/or using this data, you agree to abide by
          all of the rules and regulations.

          <ol type="1">
            <li>
              Researcher shall use the dataset only for non-commercial research
              and educational purposes.
            </li>

            <li>
              The authors with Worcester Polytechnic Institute and US Army
              Research Lab make no representations or warranties regarding the
              dataset, including but not limited to warranties of
              non-infringement or fitness for a particular purpose.
            </li>

            <li>
              Researcher accepts full responsibility for his or her use of the
              dataset and shall defend and indemnify the authors, including
              their employees, Trustees, officers and agents, against any and
              all claims arising from Researcher's use of the dataset, including
              but not limited to Researcher's use of any copies of copyrighted
              images that he or she may create from the dataset.
            </li>

            <li>
              Researcher may provide research associates and colleagues with
              access to the dataset provided that they first agree to be bound
              by these terms and conditions.
            </li>

            <li>
              The authors reserve the right to terminate Researcher's access to
              or usage of the dataset at any time.
            </li>

            <li>
              If Researcher is employed by a for-profit, commercial entity,
              Researcher's employer shall also be bound by these terms and
              conditions, and Researcher hereby represents that he or she is
              fully authorized to enter into this agreement on behalf of such
              employer.
            </li>

            <li>
              The law of the State of Massachusetts shall apply to all disputes
              under this agreement.
            </li>
          </ol>
        </mdb-modal-body>
        <mdb-modal-footer>
          <mdb-btn color="secondary" @click.native="modal = false"
            >Close</mdb-btn
          >
          <mdb-btn
            color="primary"
            type="submit"
            @click.native="modal = false"
            onclick="window.open('https://arl.wpi.edu/data/DATA_SET_FOR_RELEASE_CORROSION.zip')"
            >I Agree</mdb-btn
          >
        </mdb-modal-footer>
      </mdb-modal>
    </mdb-container>
  </section>
</template>


<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbIcon,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardText,
  mdbCardTitle,
  mdbCardImage,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
} from "mdbvue";

var image = require("@/assets/background/bg-min.jpg");

export default {
  name: "CorrosionDataset",
  components: {
    mdbContainer,
    // mdbIcon,
    mdbRow,
    mdbCol,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbCardText,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    // mdbCardTitle,
    mdbCardImage,
  },
  data() {
    return {
      modal: false,
    };
  },
};
</script>

<style scoped>
.corrosion-dataset {
  padding-top: 100px;
  min-height: 1000px;
  /* height:100%; */
  /* background: rgba(42, 27, 161, 0.7);
    background: linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%); */
}

.card-title {
  color: black;
  font-weight: 400;
}

.card-text {
  margin-top: 10px;
}

.modal-title {
  color: black;
  font-weight: 400;
}

.modal-body {
  color: black;
}

.i-white {
  /* color:#778899; */
  color: #fff;
  font-size: 20px;
  padding: 10px;
}

.citation {
  color: grey;
  font-size: 12px;
  background: #f6f8fa;
  border-radius: 10px;
  padding: 10px;
  padding-bottom: 1px;
  margin-bottom: 20px;
}

.details {
  color: #778899;
  /* font-size:12px */
  /* padding-bottom:50px!important; */
}

.max-width-col{
  max-width: 18%;
}
</style>
